import React from 'react';

/* eslint-disable */
export default props => (
  <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M512 128l-33.9 33.9L384 256H336V208 152H24 0V104H24 336V48 0h48l94.1 94.1L512 128zm-67.9 0L384 67.9V188.1L444.1 128zM488 360h24v48H488 176v56 48H128L33.9 417.9 0 384l33.9-33.9L128 256h48v48 56H488zM128 444.1V323.9L67.9 384 128 444.1z"/></svg>

)

/* eslint-enable */
